import { createFileRoute, redirect } from '@tanstack/react-router';
import { getDefaultTargetMonth } from '@/features/contract-and-cost/targetMonth';
export const Route = createFileRoute('/_staff/devices/_list/contract-and-cost/_contract-and-cost/cost/')({
  beforeLoad: () => {
    throw redirect({
      to: '/devices/contract-and-cost/cost/$targetMonth',
      params: {
        targetMonth: getDefaultTargetMonth()
      }
    });
  }
});